import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./HomeMonitor.module.css";
import { Alert, Button, Card, Form } from "react-bootstrap";
import FrequenciaApi from "../../services/FrequenciaApi";
import { FaChartLine, FaUserGroup } from "react-icons/fa6";
import { FaChartBar } from "react-icons/fa";
import BotaoProgresso from "../../components/botaoProgresso/BotaoProgresso";
import { useLocation, useNavigate } from "react-router-dom";
import GraficoFrequenciaDia from "../../components/graficoFrequenciaDia/GraficoFrequenciaDia";
import GraficoDetalheAlunos from "../../components/graficoFrequenciaPorAluno/GraficoDetalheAlunos";
import LoaderFundoTransparente from "../../components/LoaderFundoTransparente/LoaderFundoTransparente";
import HomeApi from "../../services/HomeApi";
import Alerta from "../../components/alerta/Alerta";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";
import { useSearchParams } from 'react-router-dom';
function HomeMonitor() {
    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);

    const [loading, setLoading] = useState(false);

    // Estados de dados
    const [turmas, setTurmas] = useState([]);
    const [turma, setTurma] = useState("");

    const [minimoDetalhe, setMinimoDetalhe] = useState(0);
    const [idealDetalhe, setIdealDetalhe] = useState(0);

    const [turmaSelecionada, setTurmaSelecionada] = useState();

    // Estados do gráfico
    const [tipoGrafico, settipoGrafico] = useState("line");
    const [FrequenciaHorasDia, setFrequenciaHorasDia] = useState([]);


    // Estados de alerta
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("success");
    const [mostrarAlerta, setMostrarAlerta] = useState(false);

    // Estados para detalhes'
    const [alunosDoDia, setAlunosDoDia] = useState([]);
    const [dataSelecionada, setDataSelecionada] = useState(null);
    const [limiteMinimo, setLimiteMinimo] = useState(0);
    const [limiteIdeal, setLimiteIdeal] = useState(0);
    const [totalPresente, setTotalPresente] = useState(0);


    const alunos = turma?.quantidadeAlunos ?? turmaSelecionada?.quantidadeAlunos ?? 0;

    // Estados Fakes Modle

    const [modulos, setModulos] = useState();
    const [moduloSelecionado, setModuloSelecionado] = useState(null);
    const [frequenciaPorModulo, setFrequenciaPorModulo] = useState([]);

    const [dataPresenca, setDataPresenca] = useState(() => {
        const hoje = new Date();
        return hoje.toISOString().slice(0, 7);
    });


    const [alertExibido, setAlertExibido] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();

    // Funções auxiliares
    const calcularLimites = (turno, alunosNoDia) => {
        const horasPorAluno = {
            manha: 4,
            tarde: 4,
            noite: 3,
        };

        if (!turno || !alunosNoDia || alunosNoDia.length === 0) {
            return { minimo: 0, ideal: 0, totalPresente: 0 };
        }

        const horasEsperadas = horasPorAluno[turno.toLowerCase()] || 4;
        const totalEsperado = alunosNoDia.length * horasEsperadas;
        const totalPresente = alunosNoDia.reduce((acc, aluno) => acc + (aluno.horas || 0), 0);

        const minimo = totalEsperado - 0.166; // Tolerância de 10 minutos
        const ideal = totalEsperado; // 100% das horas 

        return { minimo, ideal, totalPresente };
    };

    function calcularLimitesAluno(turno) {
        const horasPorAluno = {
            manha: 4,
            tarde: 4,
            noite: 3,
        };
        const cargaHoraria = horasPorAluno[turno.toLowerCase()] || 4;
        const tolerancia = 10 / 60; // 10 minutos

        const ideal = cargaHoraria;
        const minimo = cargaHoraria - tolerancia;

        return { minimo, ideal };
    }


    function alertas() {
        setMostrarAlerta(true)

        setTimeout(() => {
            setMostrarAlerta(false);
        }, 3000)

    }

    //Dados Fakes 


    function listarFrequenciaPorModuloFake(moduloId) {
        const dadosMock = {
            1: [
                { nomeCompleto: "Ana Souza", totalHoras: 18 },
                { nomeCompleto: "Carlos Lima", totalHoras: 20 },
                { nomeCompleto: "Beatriz Gomes", totalHoras: 14 },
                { nomeCompleto: "Ana Souza", totalHoras: 18 },
                { nomeCompleto: "Carlos Lima", totalHoras: 20 },
                { nomeCompleto: "Beatriz Gomes", totalHoras: 14 },
                { nomeCompleto: "Ana Souza", totalHoras: 18 },
                { nomeCompleto: "Carlos Lima", totalHoras: 20 },
                { nomeCompleto: "Beatriz Gomes", totalHoras: 14 },
                { nomeCompleto: "Ana Souza", totalHoras: 18 },
                { nomeCompleto: "Carlos Lima", totalHoras: 20 },
                { nomeCompleto: "Beatriz Gomes", totalHoras: 14 },
                { nomeCompleto: "Ana Souza", totalHoras: 18 },
                { nomeCompleto: "Carlos Lima", totalHoras: 20 },
                { nomeCompleto: "Beatriz Gomes", totalHoras: 14 },
                { nomeCompleto: "Ana Souza", totalHoras: 18 },
                { nomeCompleto: "Carlos Lima", totalHoras: 20 },
                { nomeCompleto: "Beatriz Gomes", totalHoras: 14 },

            ],
            2: [
                { nomeCompleto: "Ana Souza", totalHoras: 16 },
                { nomeCompleto: "Carlos Lima", totalHoras: 19 },
                { nomeCompleto: "Beatriz Gomes", totalHoras: 15 }
            ],
            3: [
                { nomeCompleto: "Ana Souza", totalHoras: 20 },
                { nomeCompleto: "Carlos Lima", totalHoras: 20 },
                { nomeCompleto: "Beatriz Gomes", totalHoras: 20 }
            ]
        };

        return dadosMock[moduloId] || [];
    }


    function listarModulosDaTurmaFake(turmaId) {
        return [
            {
                moduloId: 1,
                nome: "Módulo 1",
                dataInicio: "2024-01-01",
                dataFim: "2024-01-31"
            },
            {
                moduloId: 2,
                nome: "Módulo 2",
                dataInicio: "2024-02-01",
                dataFim: "2024-02-28"
            },
            {
                moduloId: 3,
                nome: "Módulo 3",
                dataInicio: "2024-03-01",
                dataFim: "2024-03-31"
            }
        ];
    }
    const alunosFakes = [
        { nomeCompleto: "Ana Souza", totalHoras: 1 },
        { nomeCompleto: "Carlos Lima", totalHoras: 17 },
        { nomeCompleto: "Beatriz Gomes", totalHoras: 14 },
        { nomeCompleto: "Eduardo Melo", totalHoras: 20 },
        { nomeCompleto: "Fernanda Rocha", totalHoras: 15 },
        { nomeCompleto: "Lucas Nogueira", totalHoras: 16 },
        { nomeCompleto: "Mariana Costa", totalHoras: 11 },
        { nomeCompleto: "Thiago Fernandes", totalHoras: 19 },
        { nomeCompleto: "Fernanda Rocha", totalHoras: 8 },
        { nomeCompleto: "Lucas Nogueira", totalHoras: 16 },
        { nomeCompleto: "Mariana Costa", totalHoras: 11 },
        { nomeCompleto: "Thiago Fernandes", totalHoras: 19 },
        { nomeCompleto: "Ana Souza", totalHoras: 1 },
        { nomeCompleto: "Carlos Lima", totalHoras: 17 },
        { nomeCompleto: "Beatriz Gomes", totalHoras: 14 },
        { nomeCompleto: "Eduardo Melo", totalHoras: 20 },
        { nomeCompleto: "Fernanda Rocha", totalHoras: 15 },
        { nomeCompleto: "Lucas Nogueira", totalHoras: 16 },
        { nomeCompleto: "Mariana Costa", totalHoras: 11 },
        { nomeCompleto: "Thiago Fernandes", totalHoras: 19 },
        { nomeCompleto: "Fernanda Rocha", totalHoras: 8 },
        { nomeCompleto: "Lucas Nogueira", totalHoras: 16 },
        { nomeCompleto: "Mariana Costa", totalHoras: 11 },
        { nomeCompleto: "Thiago Fernandes", totalHoras: 19 },
    ];


    // Funções de API

    const quantidadeAlunosTurmas = async () => {
        try {

            const turmasAlunos = await HomeApi.ListarTurmasComQuantidadeAlunosAsync();

            setTurmas(turmasAlunos);
            return turmasAlunos;
        } catch (error) {
            console.error("Erro ao listar turmas:", error);
            throw error;
        }

    };

    const listarHorasPorDiaFrequencia = async (turmaid, dataRef, periodoTurma) => {

        let date = new Date(`${dataPresenca}-01T00:00:00`);

        const ano = date.getFullYear();
        const mes = date.getMonth() + 1;

        try {
            const resultado = await FrequenciaApi.ListarHorasTurmasPorDiaFrequencia(turma, mes, ano);
            setFrequenciaHorasDia(resultado);

            // Definir carga horária base
            let cargaHorariaDia = 4; // padrão
            if (turmaSelecionada?.periodo === 3) {
                cargaHorariaDia = 3; // período noturno
            }
            // Tolerância (em horas)
            const tolerancia = 20 / 60; // 20 minutos

            // Ideal = carga horária exata (sem acréscimo)
            const idealPorDia = cargaHorariaDia * alunos;

            // Mínimo = carga horária menos tolerância
            const minimoPorDia = (cargaHorariaDia - tolerancia) * alunos;

            // Aqui você pode calcular média, se quiser, por exemplo:
            // const media = resultado.reduce((acc, cur) => acc + cur.horas, 0) / resultado.length;

            setLimiteIdeal(Number(idealPorDia.toFixed(2)));
            setLimiteMinimo(Number(minimoPorDia.toFixed(2)));

        } catch (error) {
            console.error("Erro ao buscar horas por dia:", error);
            throw error;
        }
    };

    const handleBarClick = async (dataClicada) => {
        try {

            setLoading(true);
            setDataSelecionada(dataClicada);
            const dataFormatada = new Date(dataClicada).toISOString().split('T')[0];
            const resultado = await FrequenciaApi.ListarFrequenciaTodosAlunos(turma, dataFormatada);

            const alunosNoDia = resultado.map(f => ({
                nome: f.NomeCompleto || f.nomeCompleto || f.nome || "Aluno",
                horas: parseFloat(f.HorasNoDia || f.horasNoDia || f.horas || f.totalHoras || 0),
            }));

            setAlunosDoDia(alunosNoDia);
            const turnoTurma = turmaSelecionada?.turno || "manha";
            const limites = calcularLimitesAluno(turnoTurma, alunosNoDia);

            setMinimoDetalhe(Number(limites.minimo.toFixed(2)));
            setIdealDetalhe(Number(limites.ideal.toFixed(2)));
            setTotalPresente(limites.totalPresente);
        } catch (error) {
            console.error("Erro ao buscar dados do dia:", error);
            setMostrarAlerta(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const alertParam = params.get("alert");

        if (alertParam === "logado_sucesso") {
            setMensagemAlerta("Logado com sucesso!");
            setTipoAlerta("success");
            setMostrarAlerta(true);
            params.delete("alert");
            navigate({ search: params.toString() }, { replace: true });
            setTimeout(() => setMostrarAlerta(false), 1000);
        }
    }, [location, navigate]);





    useEffect(() => {
        const carregarTudo = async () => {
            try {

                setLoading(true);


                // Buscar turmas e setar primeira turma como padrão
                const turmasData = await quantidadeAlunosTurmas();
                if (turmasData.length === 0) return;

                const turmaDefault = turmasData[0];
                setTurma(turmaDefault.turmaId);
                setTurmaSelecionada(turmaDefault);

                // Módulos fakes da turma
                const modulosTurma = listarModulosDaTurmaFake(turmaDefault.turmaId);
                setModulos(modulosTurma);

                if (modulosTurma.length > 0) {
                    setModuloSelecionado(modulosTurma[0]);
                    const freqModulo = listarFrequenciaPorModuloFake(modulosTurma[0].moduloId);
                    setFrequenciaPorModulo(freqModulo);
                }

                // Frequência por dia da turma
                await listarHorasPorDiaFrequencia(turmaDefault.turmaId, dataPresenca, turmaDefault.periodo);


            } catch (error) {
                console.error("Erro ao carregar dados:", error);
            } finally {
                setLoading(false);
            }
        };

        carregarTudo();
    }, []);

    const [graficoPronto, setGraficoPronto] = useState(false);

    useEffect(() => {
        if (loading) {

            setGraficoPronto(false); // Enquanto carrega, não mostra gráfico
        } else {
            // Espera 500ms após o loading terminar
            const timer = setTimeout(() => {
                setGraficoPronto(true);
                // Agora pode exibir o gráfico
            }, 600); // você pode aumentar se quiser: 1000 = 1 segundo

            return () => clearTimeout(timer); // limpeza caso o loading mude rapidamente
        }
    }, [loading]);



    useEffect(() => {
        const atualizarFrequencias = async () => {
            if (!turma || !turmaSelecionada) return;
            setLoading(true);


            try {
                await listarHorasPorDiaFrequencia(turma, dataPresenca, turmaSelecionada.periodo);
                setDataSelecionada(null);
                setAlunosDoDia([]);

            } catch (e) {
                console.error("Erro ao atualizar frequência por dia:", e);
            } finally {
                setLoading(false);
            }
        };

        atualizarFrequencias();
    }, [turma, dataPresenca]);


    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
                <div className={style.pagina_conteudo}>
                    <div className={style.alertLogado}>
                        {mostrarAlerta && (
                            <Alert variant={tipoAlerta} onClose={() => setMostrarAlerta(false)} dismissible className={style.alertaBaixoDireito}>
                                {mensagemAlerta}
                            </Alert>
                        )}
                        {loading && <LoaderFundoTransparente />}
                    </div>

                    <div className={style.SelectFundo}>
                        <div className={style.select}>
                            {turmas.length > 0 ? (
                                <Form.Select
                                    value={turma}
                                    onChange={(e) => {
                                        const turmaId = e.target.value;
                                        setTurma(turmaId);
                                        setDataSelecionada(null);
                                        const turmaObj = turmas.find((t) => t.turmaId === parseInt(turmaId));

                                        setTurmaSelecionada(turmaObj);

                                        //fakes se fosse modle 

                                        // Atualiza módulos para essa turma
                                        const modulosFakes = listarModulosDaTurmaFake(turmaId);
                                        setModulos(modulosFakes)

                                        if (modulosFakes.length > 0) {
                                            const primeiroModulo = modulosFakes[0];
                                            setModuloSelecionado(primeiroModulo);
                                            const frequencias = listarFrequenciaPorModuloFake(primeiroModulo.moduloId);
                                            setFrequenciaPorModulo(frequencias);
                                        } else {
                                            setModuloSelecionado(null);
                                            setFrequenciaPorModulo([]);
                                        }

                                    }}
                                >
                                    {turmas.map((Turma) => (
                                        <option key={Turma.turmaId} value={Turma.turmaId}>
                                            {Turma.nome}
                                        </option>
                                    ))}
                                </Form.Select>
                            ) : (
                                <Form.Select disabled>
                                    <option>Nenhuma turma disponível</option>
                                </Form.Select>
                            )}
                        </div>
                    </div>

                    <div className={style.fundo}>
                        <div className={style.container_filtro}>
                            <Button
                                onClick={() => settipoGrafico(prev => prev === "line" ? "bar" : "line")}
                                id={style.alterar_graficor}
                            >
                                {tipoGrafico === "line" ? <FaChartBar /> : <FaChartLine />}
                            </Button>

                            {dataSelecionada && (
                                <Button

                                    id={style.alterar_graficor}
                                    onClick={() => setDataSelecionada(null)}
                                >
                                    Voltar
                                </Button>
                            )}
                            <div>

                                {!dataSelecionada && (
                                    <Form.Control
                                        type="month"
                                        id="hidenDataPresenca"
                                        name="dataPresenca"
                                        value={dataPresenca}
                                        required
                                        onChange={(e) => {
                                            if (e.target.value) {
                                                setDataPresenca(e.target.value);
                                            }
                                        }}
                                        max={new Date().toISOString().slice(0, 7)}
                                    />
                                )}

                            </div>
                        </div>

                        <div className={style.canvasContainer}>
                            {loading || !graficoPronto ? (
                                <LoaderFundoTransparente />
                            ) : !dataSelecionada ? (
                                FrequenciaHorasDia.length > 0 ? (
                                    <GraficoFrequenciaDia
                                        dados={FrequenciaHorasDia}
                                        tipo={tipoGrafico}
                                        minimo={limiteMinimo}
                                        ideal={limiteIdeal}
                                        onBarClick={handleBarClick}
                                    />
                                ) : (
                                    <div className={style.cardGrafico}>
                                        <h2>Alunos sem data de presença</h2>
                                    </div>
                                )
                            ) : alunosDoDia.length > 0 ? (
                                <GraficoDetalheAlunos
                                    dados={alunosDoDia}
                                    dataSelecionada={dataSelecionada}
                                    tipo={tipoGrafico}
                                    limiteMinimo={minimoDetalhe}
                                    limiteIdeal={idealDetalhe}
                                />
                            ) : (
                                <div className={style.semDados}>
                                    <h2>Sem dados para o dia selecionado</h2>
                                </div>
                            )}
                        </div>

                    </div>

                    <div className={style.fundoinfeior}>
                        <div className={style.supeior}>


                            <Form.Select id={style.input_modulo}
                                value={moduloSelecionado?.moduloId || ""}
                                onChange={(e) => {
                                    const moduloId = parseInt(e.target.value);
                                    const modulo = modulos.find(m => m.moduloId === moduloId);
                                    setModuloSelecionado(modulo);

                                    const frequencias = listarFrequenciaPorModuloFake(moduloId);
                                    setFrequenciaPorModulo(frequencias);
                                }}
                            >
                                <option value={""}>Selecione o Módulo</option>
                                {(modulos || []).map((modulo) => (
                                    <option key={modulo.moduloId} value={modulo.moduloId}>
                                        {modulo.nome}
                                    </option>
                                ))}
                            </Form.Select>

                            <div className={style.bloco_direito_baixo}>
                                {turmas && (
                                    <div className={style.Nome}>
                                        <div className={style.IconeFundo}>
                                            <FaUserGroup />
                                        </div>
                                        <div className={style.Alunos}>Total Alunos:</div>
                                        <div className={style.quantidade}>
                                            {turmas.find(t => t.turmaId === Number(turma))?.quantidadeAlunos || '-'}
                                        </div>
                                    </div>
                                )}
                            </div>


                        </div>


                        <div className={style.container_filtro2}>


                            <div className={style.bloco}>


                                {frequenciaPorModulo.map((aluno, index) => (
                                    <div key={index}>
                                        <h2 className={style.nome_modulo}

                                        >{aluno.nomeCompleto}</h2>

                                        <BotaoProgresso value={aluno.totalHoras} />

                                    </div>
                                ))}

                            </div>
                        </div>


                    </div>

                </div>

            </Topbar >
        </Sidebar >
    );
}

export default HomeMonitor;